import parseISO from 'date-fns/parseISO';

import { CurrentUser } from 'Modules/currentUser';

import { MCQ_VIEW_STATE_KEY, MCQ_VALIDATION_STATE } from '../constants';

export function getCurrentMcqId(exercises) {
  return Object.keys(exercises).pop();
}

export function isAssessable(state) {
  return state.assessable;
}

export function getAnsweredQuestionsId({ exercises, questions, answers }) {
  const answeredQuestions = [];
  const mcqId = getCurrentMcqId(exercises);
  const allQuestions = exercises[mcqId].questions.map((questionId) => questions[questionId]);

  allQuestions.forEach((question) => {
    const allAnswers = question.answers.map((answerId) => answers[answerId]);
    const hasSelectedAnswer = allAnswers.filter((answer) => answer.selected).length > 0;
    if (hasSelectedAnswer) {
      answeredQuestions.push(question.id);
    }
  });

  return answeredQuestions;
}

export function getAnsweredQuestionsCount(entities) {
  return getAnsweredQuestionsId(entities).length;
}

export function getMcqSession(state, mcqSessionId) {
  const mcqSession = {
    questions: [],
  };

  Object.keys(state.entities.questions).forEach((question) => {
    const answersIds = state.entities.questions[question].answers;
    const answers = [];

    answersIds.forEach((answerId) => {
      answers.push(state.entities.answers[answerId]);
    });

    mcqSession.questions.push({
      answers,
      id: parseInt(question, 10),
    });
  });

  mcqSession.id = state.currentExerciseId;
  mcqSession.assessable = isAssessable(state);
  mcqSession.exerciseSessionId = isAssessable(state) ? mcqSessionId : null;

  return mcqSession;
}

export function hasPendingSave(state) {
  return state[MCQ_VIEW_STATE_KEY].savedStatuses.hasPendingSave;
}

export function getCurrentExerciseSessionId(state) {
  const mcqViewState = state[MCQ_VIEW_STATE_KEY];
  const { currentExerciseId } = mcqViewState;
  const { exercises } = mcqViewState.entities;
  return exercises[currentExerciseId].exerciseSessionId;
}

export function getCurrentMcqIdFromState(state) {
  const mcqViewState = state[MCQ_VIEW_STATE_KEY];
  return mcqViewState.currentExerciseId;
}

export function getValidationState(state) {
  const userInformation = state.mcq_view ? state.mcq_view.userInformation : state.userInformation;
  const { isCompleted, isPassed, isReTakeAble } = userInformation;
  let reinitializationAvailableAt;

  if (userInformation.reinitializationAvailableAt !== null) {
    reinitializationAvailableAt = parseISO(userInformation.reinitializationAvailableAt);
  }

  const nowDate = new Date();

  if (isCompleted === null) {
    return MCQ_VALIDATION_STATE.UNKNOWN;
  }

  if (!isCompleted) {
    return MCQ_VALIDATION_STATE.NOT_SUBMITTED;
  }

  if (isPassed) {
    return MCQ_VALIDATION_STATE.SUCCESSFUL;
  }

  if (isCompleted && !isPassed && isReTakeAble && reinitializationAvailableAt > nowDate) {
    return MCQ_VALIDATION_STATE.UNSUCCESSFUL_AND_SUBMITABLE_LATER;
  }

  if (isCompleted && !isPassed && isReTakeAble && reinitializationAvailableAt < nowDate) {
    return MCQ_VALIDATION_STATE.UNSUCCESSFUL_AND_SUBMITABLE;
  }

  if (isCompleted && !isPassed && !isReTakeAble) {
    return MCQ_VALIDATION_STATE.UNSUCCESSFUL_AND_NOT_SUBMITABLE;
  }

  return false;
}

export function isResettingMcq(state) {
  return state.mcq_view.userInformation.isResettingMcq;
}

export function isAdminMode(state) {
  if (!CurrentUser.hasCurrentUser()) {
    return false;
  }
  return parseInt(state.mcq_view.userInformation.exerciseUserId, 10) !== CurrentUser.get().id;
}
